export var initialState = {
    type: undefined,
    data: {},
    showButton: false
};
